import { Text } from "@mantine/core";
import { DataGridSelectionKeys, DBStatusResult, Entity, EntityClientAction, LookupFormAction } from "@mcurros2/microm";
import { ClientesProductos } from "../ClientesProductos/ClientesProductos";
import { ClientesTiendasProductos } from "./ClientesTiendasProductos";

export const ACTSeleccionarProductos: EntityClientAction = {
    name: 'ACTSeleccionarProductos',
    label: 'Seleccionar productos',
    title: <Text fw={700}>Seleccionar productos</Text>,
    refreshOnClose: true,
    dontRequireSelection: true,
    views: ['ctip_brwStandard'],
    onClick: async ({ entity, modal, selectedKeys, element, onClose }) => {
        // cast entity
        const parent = entity as ClientesTiendasProductos;
        const productos = new ClientesProductos(entity.API.client);
        productos.parentKeys = parent.parentKeys;

        if (modal) {
            await modal.open({
                modalProps: {
                    title: <Text fw="700">Seleccionar productos</Text>,
                    size: 'xl'
                },
                focusOnClosed: element,
                content: <LookupFormAction
                    lookupEntity={productos}
                    viewName={productos.def.views.clpr_brwStandard.name}
                    title="Agregar productos seleccionados"
                    onActionFinished={async () => { if (onClose) await onClose(); }}
                    onOK={
                        async (keys: DataGridSelectionKeys, abortSignal: AbortSignal): Promise<DBStatusResult> => {
                            const clientes_tiendas_productos = Entity.clone(parent) as ClientesTiendasProductos;

                            clientes_tiendas_productos.def.columns.c_cliente_id.value = parent.parentKeys[clientes_tiendas_productos.def.columns.c_cliente_id.name] as string;
                            clientes_tiendas_productos.def.columns.c_tienda_id.value = parent.parentKeys[clientes_tiendas_productos.def.columns.c_tienda_id.name] as string;

                            const result = await clientes_tiendas_productos.API.addData(abortSignal, keys, true);

                            return result;
                        }
                    }
                />

            });
        }
        else {
            console.log('modal context not found');
        }

        return Promise.resolve(false);

    }

}

